module.exports = __webpack_public_path__ + "img/empty-right-projects.a2593f39.svg";